import { render, staticRenderFns } from "./SbpImageModal.vue?vue&type=template&id=343cc9af&scoped=true&"
import script from "./SbpImageModal.vue?vue&type=script&lang=js&"
export * from "./SbpImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343cc9af",
  null
  
)

export default component.exports